module.exports = function() {
  return new Worker(__webpack_public_path__ + "72afc09102396828deca.worker.js");
};